import { Link } from 'react-router-dom';
import type { SystemInfo } from '../types';
import clsx from 'clsx';

interface SystemCardProps {
  system: SystemInfo;
}

const colorClasses = {
  blue: 'bg-blue-50 border-blue-200 hover:border-blue-400',
  green: 'bg-green-50 border-green-200 hover:border-green-400',
  purple: 'bg-purple-50 border-purple-200 hover:border-purple-400',
  pink: 'bg-pink-50 border-pink-200 hover:border-pink-400',
  yellow: 'bg-yellow-50 border-yellow-200 hover:border-yellow-400',
};

export default function SystemCard({ system }: SystemCardProps) {
  const colorClass = colorClasses[system.color as keyof typeof colorClasses] || colorClasses.blue;

  if (!system.enabled) {
    return (
      <div className={clsx('card opacity-60 cursor-not-allowed', colorClass)}>
        <div className="flex items-start">
          <div className="flex-shrink-0">
            <div className="w-12 h-12 rounded-lg bg-white flex items-center justify-center text-3xl">
              {system.icon}
            </div>
          </div>
          <div className="ml-4 flex-1">
            <h3 className="text-lg font-semibold text-gray-900">{system.name}</h3>
            <p className="mt-1 text-sm text-gray-600">{system.description}</p>
            <div className="mt-4">
              <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-200 text-gray-700">
                Coming Soon
              </span>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <Link
      to={`/${system.id}`}
      className={clsx(
        'card border-2 transition-all duration-200 hover:shadow-lg',
        colorClass
      )}
    >
      <div className="flex items-start">
        <div className="flex-shrink-0">
          <div className="w-12 h-12 rounded-lg bg-white shadow-sm flex items-center justify-center text-3xl">
            {system.icon}
          </div>
        </div>
        <div className="ml-4 flex-1">
          <h3 className="text-lg font-semibold text-gray-900">{system.name}</h3>
          <p className="mt-1 text-sm text-gray-600">{system.description}</p>
          <div className="mt-4 flex items-center justify-between">
            <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
              Available
            </span>
            <span className="text-sm font-medium text-gray-900">
              Start →
            </span>
          </div>
        </div>
      </div>
    </Link>
  );
}
